import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './BarGerentePage.css';
import TituloComponent from '../../components/Titulo/TituloComponent';

const BarGerente = () => {
  const navigate = useNavigate();
  
  // Pega os dados da sessão diretamente
  const userData = JSON.parse(sessionStorage.getItem('userData')); // Assume que os dados estão armazenados no sessionStorage
  const statusUsuario = userData?.statusUsuario;
  const nomePerfil = userData?.dadosPerfil?.nome;
  const nomeUsuario = userData?.user.name;

  const [isAuthorized, setIsAuthorized] = useState(true);

  useEffect(() => {
    // Verifica se o usuário tem o perfil correto e está logado
    if (!userData || userData.dadosPerfil?.nome !== 'BAR GERENTE' || userData.statusUsuario !== 'logado') {
      console.log(' !!!! Perfil não autorizado ou usuário não logado. Redirecionando...');
      setIsAuthorized(false); // Atualiza o estado de autorização
      navigate('/area-restrita'); // Redireciona para a página de login ou área restrita
    } else {
      console.log('--- PAGINA BAR GERENTE ---');
      console.log('Dados completos do usuário:', userData);
      console.log('Status do usuário:', statusUsuario);
      console.log('Perfil do usuário:', nomePerfil);
    }
  }, [userData, statusUsuario, nomePerfil, navigate]);

  // Função para fazer o logout
  const handleLogout = () => {
    // Remove os dados da sessão
    // sessionStorage.removeItem('userData');
    // Remove todos os dados da sessão
    sessionStorage.clear();
    // Redireciona para a página de login
    navigate('/area-restrita');
  };

  // Função para redirecionar para DadosDoEstabelecimentoPage
  const handleGoToDadosEstabelecimento = () => {
    navigate('/dados-do-estabelecimento'); // Redireciona para a página de Dados do Estabelecimento
  };

  if (!isAuthorized) {
    return <div>Redirecionando...</div>; // Mostra uma mensagem enquanto redireciona
  }

  return (
    <div className="bar-gerente-container">
        <TituloComponent />
        <h1 className="usuario-logado-title">Área do Gerente</h1>
        <div className="bar-gerente-box">
            {/* Exibe o nome do perfil do usuário */}
            <p className="bar-gerente-welcome">Bem-vindo, {nomeUsuario}!</p>
            {/* Botão de Logout */}
            <button className="bar-gerente-btn" onClick={handleLogout}>Logout</button>
        </div>
        
        {/* Container de quadros */}
        <div className="bar-gerente-quadros-container">
            <div className="bar-gerente-quadro" onClick={handleGoToDadosEstabelecimento}>
                <h3>Dados do Estabelecimento</h3>
                <p>Edite as informações sobre o seu Estabelecimento.</p>
            </div>
            <div className="bar-gerente-quadro">
                <h3>Solicitações de Relacionamento</h3>
                <p>Gerencie as solicitações de relacionamento, onde as solicitações dos seus funcionários aparecerão.</p>
            </div>
            <div className="bar-gerente-quadro">
                <h3>Mesas do Estabelecimento</h3>
                <p>Edite as informações sobre as mesas do seu Estabelecimento.</p>
            </div>
            <div className="bar-gerente-quadro">
                <h3>Planos</h3>
                <p>Gerencie os planos de serviço oferecidos.</p>
            </div>
            <div className="bar-gerente-quadro">
                <h3>Produtos</h3>
                <p>Veja e administre os produtos do seu Estabelecimento.</p>
            </div>
        </div>
    </div>
  );
};

export default BarGerente;
